const GET_WORK_ORDERS = `
  query GetWorkOrders {
    workOrders: work_orders(order_by: {work_order_number: desc}) {
      description
      createdAt: created_at
      afterHours: after_hours
      workOrderNumber: work_order_number
      status {
        name
      }
    }
  }
`

export default GET_WORK_ORDERS
